/* eslint-disable react/require-default-props */
import React from "react";
import { FieldProps } from "formik";
import MaskedInput from "react-text-mask";
import { cx } from "@emotion/css";
import { customMasks } from "../support/customMasks";
import formGroupStyles from "../css/formgroup.module.css";

interface OtherProps {
  label: string;
  mask: string;
  guide?: boolean;
  onChange?: () => void;
}

type FieldCustomMaskProps = FieldProps & OtherProps;

export const FieldCustomMask = ({
  guide,
  mask,
  label,
  field,
  onChange,
  form: { touched, errors, setFieldValue, setFieldTouched, handleBlur }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...rest
}: FieldCustomMaskProps) => {
  const fieldClasses = cx(
    formGroupStyles["form-group"],
    touched[field.name] && errors[field.name] ? formGroupStyles.error : ""
  );

  // const customMask = css`
  //   font-size: 14px;
  //   color: #808080a1;
  // `;

  // const italicClass = css`
  //   font-style: italic;
  // `;

  // const displayNone = css`
  //   display: none !important;
  // `;

  return (
    <div className={fieldClasses}>
      <label htmlFor={field.name}>{label}</label>
      <div className={formGroupStyles["input-group"]}>
        <MaskedInput
          {...rest}
          guide={guide}
          value={field.value}
          placeholderChar={"\u2000"}
          keepCharPositions
          id={field.name}
          mask={customMasks(mask)}
          defaultValue={field.value}
          onChange={e => {
            setFieldValue(field.name, e.currentTarget.value);
            if (onChange) {
              onChange();
            }
          }}
          onBlur={e => {
            setFieldTouched(field.name);
          }}
          type="text"
          spellCheck="false"
        />
        {/* <span className={cx(format ? italicClass : displayNone)}>{format}</span> */}
        <div className={formGroupStyles["error-messages"]}>
          {touched[field.name] && errors[field.name] && (
            <div id={`${field.name}ErrorMessage`}>
              {errors[field.name] as React.ReactNode}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FieldCustomMask;
